import FitParser from 'fit-file-parser';
import { calculateDistance } from '../gpx/parse.js';

/**
 * Parse a FIT file ArrayBuffer into the unified trackpoint format.
 * Returns the same shape as parseGPX but with timestamps and optional metrics.
 */
export async function parseFIT(arrayBuffer) {
  const parser = new FitParser({
    force: true,
    speedUnit: 'km/h',
    lengthUnit: 'km',
    temperatureUnit: 'celcius',
    elapsedRecordField: true,
    mode: 'list'
  });

  const parsed = await parser.parseAsync(arrayBuffer);

  if (!parsed?.records || parsed.records.length === 0) {
    throw new Error('FIT file contains no trackpoint records');
  }

  const trackpoints = [];
  let cumulativeDistance = 0;

  for (let i = 0; i < parsed.records.length; i++) {
    const record = parsed.records[i];

    const lat = record.position_lat;
    const lon = record.position_long;
    if (lat == null || lon == null) continue;

    const ele = record.altitude ?? record.enhanced_altitude ?? 0;
    const timestamp = record.timestamp ? new Date(record.timestamp) : null;

    if (trackpoints.length > 0) {
      const prev = trackpoints[trackpoints.length - 1];
      cumulativeDistance += calculateDistance(prev.lat, prev.lon, lat, lon);
    }

    trackpoints.push({
      lat,
      lon,
      ele,
      cumulativeDistance,
      timestamp,
      heartRate: record.heart_rate ?? null,
      cadence: record.cadence ?? null,
      power: record.power ?? null,
      speed: record.speed ?? record.enhanced_speed ?? null
    });
  }

  if (trackpoints.length < 2) {
    throw new Error('FIT file must contain at least 2 valid GPS trackpoints');
  }

  return trackpoints;
}
